import securitiesLocalStorage from 'utils/securitiesLocalStorage';
import { AccountTypeEnum } from 'global/Securities/types/api/auth';

const useIsSyariahUser = () => {
  const { accountType } = securitiesLocalStorage.getSecuritiesAccountInfo();

  return accountType === AccountTypeEnum.SYARIAH;
};

export default useIsSyariahUser;
